{
  "meta": {
    "industry": "Retail",
    "fiscalYear": "FY2026",
    "currency": "USD"
  },
  "charts": {
    "monthlyActiveViewers": {
      "type": "bar",
      "title": "Monthly Active Customers (M)",
      "containerClass": "chartCard",
      "data": [
        { "month": "Feb", "viewers": 5.8 },
        { "month": "Mar", "viewers": 6.1 },
        { "month": "Apr", "viewers": 6.4 },
        { "month": "May", "viewers": 6.9 },
        { "month": "Jun", "viewers": 7.2 },
        { "month": "Jul", "viewers": 7.6 },
        { "month": "Aug", "viewers": 7.3 },
        { "month": "Sep", "viewers": 7.0 },
        { "month": "Oct", "viewers": 7.4 }
      ],
      "xKey": "month",
      "yKey": "viewers",
      "barColor": "hsl(202, 100%, 50%)",
      "barRadius": [4, 4, 0, 0],
      "heightPercent": 85,
      "tooltip": {
        "suffix": "M customers",
        "decimals": 1
      }
    },
    "audienceSplit": {
      "type": "pie",
      "title": "Sales Split: Online vs In-Store",
      "containerClass": "chartCard",
      "data": [
        { "name": "Online", "value": 44, "color": "hsl(202, 100%, 50%)" },
        { "name": "In-store", "value": 56, "color": "hsl(214, 32%, 75%)" }
      ],
      "tooltip": {
        "suffix": "%",
        "includeLabel": true
      },
      "layout": "side",
      "legend": {
        "items": [
          { "text": "Online: 44% (~$1.1B)", "dotClass": "secondary" },
          { "text": "In-store: 56% (~$1.4B)", "dotClass": "border" }
        ]
      }
    },
    "topSeries": {
      "type": "bar-horizontal",
      "title": "Top Categories by Revenue (Q4, $M)",
      "containerClass": "chartCardSmall",
      "data": [
        { "title": "Apparel", "hours": 420 },
        { "title": "Home & Kitchen", "hours": 310 },
        { "title": "Electronics", "hours": 275 }
      ],
      "categoryKey": "title",
      "valueKey": "hours",
      "barColor": "hsl(202, 100%, 50%)",
      "barRadius": [0, 4, 4, 0],
      "height": 180,
      "yAxisWidth": 140,
      "tooltip": {
        "suffix": "M"
      }
    },
    "completionRate": {
      "type": "pie",
      "title": "On-Time Delivery Rate",
      "containerClass": "chartCardSmall",
      "data": [
        { "name": "On-time", "value": 92, "color": "hsl(142, 76%, 36%)" },
        { "name": "Late", "value": 8, "color": "hsl(0, 84%, 60%)" }
      ],
      "tooltip": {
        "suffix": "%",
        "includeLabel": true
      },
      "layout": "side",
      "flexClass": "chartFlex chartHeight44",
      "legend": {
        "size": "small",
        "items": [
          { "text": "On-time: 92%", "color": "hsl(142, 76%, 36%)" },
          { "text": "Late: 8%", "color": "hsl(0, 84%, 60%)" }
        ]
      }
    },
    "topCreators": {
      "type": "bar",
      "title": "Top Products by Units Sold (Weekly, K)",
      "containerClass": "chartCardSmall gridSpan2",
      "data": [
        { "name": "Everyday Crew Tee", "value": 86 },
        { "name": "Nonstick Fry Pan Set", "value": 62 },
        { "name": "Wireless Earbuds", "value": 55 }
      ],
      "xKey": "name",
      "yKey": "value",
      "barColor": "hsl(142, 76%, 36%)",
      "barRadius": [4, 4, 0, 0],
      "height": 180,
      "tooltip": {
        "suffix": "K",
        "decimals": 0
      },
      "legend": {
        "show": true
      },
      "barName": "Units sold (K)"
    }
  },
  "conversations": [
    {
      "question": "did july's customer spike carry into october",
      "pauseAfterResponseMs": 4900,
      "blocks": [
        { "type": "chart", "chartId": "monthlyActiveViewers", "delayMs": 1600 },
        { "type": "chart", "chartId": "audienceSplit", "delayMs": 2100 },
        {
          "type": "paragraph",
          "text": "Active customers rose from 5.8M in Feb to a peak of 7.6M in Jul, dipped in Aug/Sep, and rebounded to 7.4M in Oct. Revenue is still weighted to in-store (56%), with online contributing 44% in Q4.",
          "delayMs": 0
        }
      ]
    },
    {
      "question": "what categories drove that momentum in q4",
      "pauseAfterResponseMs": 2500,
      "blocks": [
        { "type": "chart", "chartId": "topSeries", "delayMs": 1200 },
        {
          "type": "paragraph",
          "text": "Q4 revenue is led by Apparel ($420M), followed by Home & Kitchen ($310M) and Electronics ($275M). Together they total $1.01B and explain most of the strength we see carrying into Oct.",
          "delayMs": 0
        }
      ]
    },
    {
      "question": "which products are carrying weekly volume in those categories",
      "pauseAfterResponseMs": 2500,
      "blocks": [
        { "type": "chart", "chartId": "topCreators", "delayMs": 1250 },
        {
          "type": "paragraph",
          "text": "Weekly unit volume is concentrated in a few hero SKUs: Everyday Crew Tee (86K/week), Nonstick Fry Pan Set (62K/week), and Wireless Earbuds (55K/week). These are the first items to watch when demand re-accelerates.",
          "delayMs": 0
        }
      ]
    },
    {
      "question": "can we fulfill if those hero skus spike again",
      "blocks": [
        { "type": "chart", "chartId": "completionRate", "delayMs": 2500 },
        { "type": "heading", "text": "What this means for peak weeks", "delayMs": 0 },
        {
          "type": "paragraph",
          "text": "On-time delivery is 92%, with 8% late shipments showing where peak-season strain appears first. If hero SKUs surge, the main risk is fulfillment capacity during high-volume weeks—so tying demand signals to staffing, carrier performance, and inventory positioning is the fastest way to protect the customer experience.",
          "delayMs": 0
        }
      ]
    }
  ]
}